import EssayReplyModel from '@/dex-shared/models/EssayReplyModel';
import ContentModel from '@/dex-shared/models/ContentModel';
import TextModel from '@/dex-shared/models/TextModel';

export default {
  essays: (state: any, getters: any) => {
    return Object.values(state.essay_replies)
      .map((essayReply: any) => new EssayReplyModel(essayReply, getters))
      .sort(
        (a: EssayReplyModel, b: EssayReplyModel) => +b.updatedAt - +a.updatedAt,
      );
  },
  drafts: (state: any, getters: any) => {
    return getters.essays.filter(
      (essayReply: any) => essayReply.status == 'DRAFT',
    );
  },
  essayReplyById: (state: any, getters: any) => (essayReplyId: number) => {
    let essayReply = state.essay_replies[essayReplyId];
    if (essayReply) {
      return new EssayReplyModel(essayReply, getters);
    } else {
      return {};
    }
  },
  essayByPosition: (state: any, getters: any) => (
    subjectSlug: string,
    essayPosition: number,
  ) => {
    let essay = getters.essays.find((essayReply: EssayReplyModel) => {
      return (
        essayReply.subject().slug == subjectSlug &&
        essayReply.position == essayPosition
      );
    });
    if (essay) {
      return essay;
    } else {
      return {};
    }
  },
  contentById: (state: any, getters: any) => (contentId: number) => {
    let content = state.contents[contentId];
    if (content) {
      return new ContentModel(content, getters);
    } else {
      return {};
    }
  },
  contentsByEssayReplyId: (state: any, getters: any) => (
    essayReplyId: number,
  ) => {
    return Object.values(state.contents)
      .map((content: any) => new ContentModel(content, getters))
      .filter((content: ContentModel) => content.essayReplyId === essayReplyId);
  },
  textById: (state: any, getters: any) => (textId: number) => {
    let text = state.texts[textId];
    if (text) {
      return new TextModel(text, getters);
    } else {
      return {};
    }
  },
};
